import { render, staticRenderFns } from "./EducatorCreate.vue?vue&type=template&id=35bf49b8"
import script from "./EducatorCreate.vue?vue&type=script&lang=ts"
export * from "./EducatorCreate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports